<form [formGroup]="form" (submit)="login()">
  <div *ngIf="authError" class="alert alert-danger" role="alert">
    <a class="alert-link" lang>login.incorrect-user</a>
  </div>
  <div *ngIf="timeoutError" class="alert alert-danger" role="alert">
    <a class="alert-link" lang>auth.error</a>
  </div>
  <!-- Username -->
  <div class="form-group input-group">
    <input name="username" formControlName="username" class="form-control form-input"
      placeholder="{{ 'auth.username-placeholder' | lang }}" type="text"
      [ngClass]="{ 'is-invalid':submitted && f.username.errors }">
  </div>

  <div class="form-group input-group">
    <input name="password" class="form-control form-input" placeholder="{{ 'signup.password-placeholder' | lang }}" formControlName="password"
      type="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
  </div>

  <div class="options">
    <label class="remember-me">
      <input type="checkbox" formControlName="rememberMe" id="rememberMe" value="rememberMe">
      <a class="center" lang>login.remember-me</a>
    </label>

    <a class="btn forgot-password" langLink="/forgot-password" lang>login.forgot-password</a>
  </div>

  <div class="form-group">
    <button class="btn login" lang>login.login-button</button>
  </div> <!-- form-group// -->
  <hs-spinner [show]="loading"></hs-spinner>
</form>
